var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningSmRdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.997,
    height: 17.243,
    viewBox: "0 0 18.997 17.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning-sm-rd-icon",
    d: "M12.069,3.49l7.96,14.4H4.109l7.961-14.4Zm0-1.562a1.375,1.375,0,0,0-1.129.752L2.831,17.348c-.621,1-.093,1.823,1.174,1.823H20.133c1.267,0,1.8-.82,1.174-1.823h0L13.2,2.68A1.375,1.375,0,0,0,12.069,1.928Zm1.187,14.01a1.193,1.193,0,1,1-1.187-1.078A1.136,1.136,0,0,1,13.256,15.938Zm-1.187-2.155A1.136,1.136,0,0,1,10.882,12.7V9.472a1.193,1.193,0,0,1,2.375,0V12.7A1.136,1.136,0,0,1,12.069,13.782Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#fc4646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSmRdIcon);
export default __webpack_public_path__ + "static/media/warning-sm-rd-icon.35e3185004e469a4eb72662fab28e3c3.svg";
export { ForwardRef as ReactComponent };